import { chain, groupBy } from 'lodash';

export default {
  groupedActionNotifications: (state) => {
    return chain(state.userActionNotifications)
      .filter((notification) => !!notification.group)
      .groupBy('group')
      .omitBy((value) => value.length < 2)
      .value();
  },

  ungroupedActionNotifications: (state) => {
    const groupedNotifications = groupBy(state.userActionNotifications, 'group');

    return state.userActionNotifications.filter((notification) => {
      return !notification.group || (notification.group && groupedNotifications[notification.group]?.length < 2);
    });
  },

  groupedNonActionNotifications: (state) => {
    return chain(state.userNonActionNotifications)
      .filter((notification) => !!notification.group)
      .groupBy('group')
      .omitBy((value) => value.length < 2)
      .value();
  },

  ungroupedNonActionNotifications: (state) => {
    const groupedNotifications = groupBy(state.userNonActionNotifications, 'group');

    return state.userNonActionNotifications.filter((notification) => {
      return !notification.group || (notification.group && groupedNotifications[notification.group]?.length < 2);
    });
  },

  userNotifications: (state) => {
    return [...state.userActionNotifications, ...state.userNonActionNotifications];
  },

  hasUnviewedNotifications: (state) => {
    return state.userNonActionNotifications.some((notification) => !notification.viewed);
  },

  hasNotificationsWithActiveAction: (state) => {
    return !!state.userActionNotifications.length;
  },
};
